<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <filter-layout
    title="가격대"
    :sub-title="getRangeString"
    :sub-title-style="{
      color: '#3c6bbb',
      'font-size': '1.4rem'
    }"
    padding-x="3.2rem"
    padding-y="3rem"
    width="40rem"
    class="money-filter"
    v-show="isShow"
  >
    <div class="slider-view">
      <vue-slider
        v-model="moneyRange"
        :height="10"
        :min="0"
        :max="120"
        :dotStyle="{
          width: '1.8rem',
          height: '1.8rem',
          border: '2px solid #3c6bbb',
          'box-shadow': 'none'
        }"
        :processStyle="{
          'background-color': '#3c6bbb'
        }"
        :marks="marks"
        :labelStyle="{
          'line-height':'100%',
          'font-size': '12px',
          'font-weight': 'bold',
          'color': '#999999'
        }"
        tooltip='none'
        @drag-end="changedRange"
        />
    </div>
  </filter-layout>
</template>

<script>
  import FilterLayout from '../Layout/FilterLayout'

  export default {
    name: 'MoneyFilter',
    components: {FilterLayout},
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        moneyRange: [0, 120],
        marks: {
          '0': 0,
          '60': 60,
          '120': '무제한'
        }
      }
    },
    methods: {
      changedRange () {
        console.log(this.moneyRange)
        this.$store.dispatch('setMoneyRange', this.moneyRange)
      }
    },
    computed: {
      getRangeString () {
        const firstString = this.moneyRange[0] === 0 && this.moneyRange[1] === 120 ? '' : `${this.moneyRange[0] === 0 ? `${this.moneyRange[0]}` : `${this.moneyRange[0]} 만 원`}`
        const lastString = this.moneyRange[1] === 120 ? '무제한' : `${this.moneyRange[1]} 만 원`

        return `${firstString} ${(lastString === '무제한' && !firstString) ? '' : '~'} ${lastString}`
      }
    }
  }
</script>

<style scoped lang="less">
  .slider-view {
    color: black;
    padding-bottom: 1rem;
  }
</style>
<style>
  .money-filter .vue-slider-dot {
    width: 1.8rem !important;
    height: 1.8rem !important;
  }
</style>
